export function generateLngLatUrl(lngLat){
    if(lngLat && Array.isArray(lngLat) && lngLat.length === 2)
    {
        return "/lng/" + lngLat[0] + "/lat/" + lngLat[1];
    }
    else return "";
}